import { useState, useEffect } from 'react';
import ConfirmModal from './ConfirmModal';
import HistoryTimeline from './HistoryTimeline';
import { APIClient } from "../helpers/api_helper";
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Form, Input, Row, Segmented, Space } from 'antd';

const api = new APIClient();


const PersonDrawer = (props) => {
  const [form] = Form.useForm();
  const [activeDrawerTab, setActiveDrawerTab] = useState('data');
  const [showDeletionConfirmModal, setShowDeletionConfirmModal] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    setActiveDrawerTab('data');
    if (props.id) {
      try {
        api.get(`/api/persons/${props.id}/`, {})
          .then(resp => {
            setData(resp);
            form.setFieldsValue(resp);
          });
      } catch (error) {
        console.error(error);
      }
    } else {
      form.resetFields();
      setData(null);
    }
  }, [props.isOpen, props.id]);


  const handleCancel = () => {
    form.resetFields();
    props.onCancel()
  }

  const handleConfirmedDelete = () => {
    api.delete(`/api/persons/${props.id}/`, {}, {successMsg: `Oseba uspešno izbrisana ${props.id}: ${data.title}`})
      .then(resp => {
        props.onDone()
        form.resetFields();
        setShowDeletionConfirmModal(false);
      })
      .catch(error => {
        console.error(error)
      })
  };

  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const payload = { ...values };

        const isEdit = props.id !== null;
        const apiCall = isEdit
            ? api.update(`/api/persons/${props.id}/`, payload)
            : api.create('/api/persons/', payload, {successMsg: `Oseba uspešno ustvarjena ${payload.title}`});

        apiCall.then(resp => {
            props.onDone();
            form.resetFields();
          }).catch(err => console.error('API error:', err));
      })
      .catch((info) => {
        console.error('Validate Failed:', info);
      });
  };

  const isCreation = props.id == null;

  return (
    <>
      <Form layout="vertical" form={form}>
        <Drawer
          title={
            <Space>
              <span>{isCreation ? "Ustvari novo osebo" : `Oseba #${props.id}`}</span>
              {!isCreation && (
                <Segmented
                  size="small"
                  value={activeDrawerTab}
                  onChange={setActiveDrawerTab}
                  options={[
                    { label: 'Podatki', value: 'data' },
                    { label: 'Zgodovina', value: 'history' },
                  ]}
                />
              )}
            </Space>
          }
          width={560}
          onClose={handleCancel}
          open={props.open}
          extra={
            activeDrawerTab === 'data' && (
              <Space>
                <Button disabled={isCreation} onClick={() => setShowDeletionConfirmModal(true)} danger><DeleteOutlined /></Button>
                <Button onClick={handleCancel}><CloseOutlined /></Button>
                <Button disabled={false} onClick={onSubmit} type="primary">Shrani</Button>
              </Space>
            )
          }
        >
          {activeDrawerTab === 'data' && (
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="title"
                  label='Ime in priimek'
                  rules={[{ required: true, message: 'Prosim vnesite ime in priimek' }]}
                >
                  <Input placeholder={'ime in priimek...'} />
                </Form.Item>
              </Col>
            </Row>
          )}

          {activeDrawerTab === 'history' && (
            <HistoryTimeline model="Person" objectId={props.id} />
          )}
        </Drawer>
      </Form>

      <ConfirmModal
        textComponent={<p>{`Ali ste prepričani, da želite izbrisati osebo #${data?.id}?`}</p>}
        open={showDeletionConfirmModal}
        confirmBtnTitle='Izbriši'
        confirmBtnProps={{'danger': true}}
        onOk={() => handleConfirmedDelete()}
        onCancel={() => {
          setShowDeletionConfirmModal(false);
        }}
      />
    </>
  );
};

export default PersonDrawer;
